import { render, staticRenderFns } from "./coper.vue?vue&type=template&id=5c1e549f&scoped=true&"
import script from "./coper.vue?vue&type=script&lang=js&"
export * from "./coper.vue?vue&type=script&lang=js&"
import style0 from "./coper.vue?vue&type=style&index=0&id=5c1e549f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1e549f",
  null
  
)

export default component.exports